export default __webpack_public_path__ + "58392e5d430bf6292291dc88ae46d084.png";